import { NgModule } from '@angular/core';
import { ioteqUtilsService } from '@tools/services/utils/utils.service';

@NgModule({
    providers: [
        ioteqUtilsService
    ]
})
export class ioteqUtilsModule
{
    /**
     * Constructor
     */
    constructor(private _ioteqUtilsService: ioteqUtilsService)
    {
    }
}
